export default "__VITE_ASSET__DHVT4Ign__"